var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconAndTextHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420.23 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9caed5;\n      }\n\n      .cls-2 {\n        fill: #2b7db9;\n      }\n\n      .cls-3 {\n        fill: #2d56a6;\n      }\n\n      .cls-4 {\n        fill: #4eacc1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m47.63,57.26v.15L0,83.7l6.81,3.75,47.63-26.28v-.13l-6.68-3.7-.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m74.84,42.39l3.12-1.72-3.12,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.84,72.44l-47.61,26.28,6.79,3.75,47.63-26.28v-.05l-6.81-3.77v.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m88.46,79.95l-47.63,26.28,6.79,3.75,47.63-26.28-6.79-3.77v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.23,64.92l-47.63,26.3,6.81,3.75,47.63-26.3v-.08l-6.81-3.77v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.76,57.33l6.68,3.7v-7.39l-6.68,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.96,40.67l-3.12,1.72v29.99l6.81,3.77v-37.51l-3.69,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.46,34.86v45.06l6.79,3.77V31.11l-6.79,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.23,49.89v14.93l6.81,3.77v-22.45l-6.81,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m47.76,54.92l-.13-.08v.17l.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.63,0L0,27.49v55l.13.08,47.49,27.43v-55l.13.08,47.49-27.43v-.17L47.63,0ZM14.46,82.77l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Zm13.61,38.72l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Zm13.61,38.72l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Zm0-15.57l-7.65-4.27v-8.76l7.65,4.27v8.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.78,
    y: 9.31,
    width: 15.38,
    height: 7.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m123.48,23.52v-14.19c0-.89.72-1.6,1.6-1.6h38.6c1,0,1.76.91,1.58,1.89l-6.35,34.77c-.14.76-.8,1.31-1.57,1.31h-15.92v-7.31h7.56l4.33-23.36h-19.82v8.5h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m174.6,45.67v-7.27s0-.02.02-.02c0,0,19.27,0,19.27-.01l9.95-29.03s1.01-.01,1.02-.01c0,0,11.86.01,11.85.03l-13.1,35.3c-.23.63-.83,1.05-1.5,1.05h-27.49s-.02,0-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m226.04,45.69l3.56-32.25h9l-3.56,32.25h-9Zm17.88-39.38h10v29.7l15.25-2.95v7.19l-23.33,5.04c-.99.21-1.92-.55-1.92-1.57V6.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.66 80 174.66 83.37 174.66 88 217.78 88 217.78 83.37 217.78 80 174.66 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "278.49 22 278.49 25.37 278.49 30 321.61 30 321.61 25.37 321.61 22 278.49 22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m369.81,27.88h-11l2.38,10.68h-18.29l5.66-32.24h-11l-6.61,37.5c-.17.98.58,1.88,1.58,1.88h39.23c1.02,0,1.78-.95,1.56-1.95l-3.51-15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m147.85,103.69v-25.7l-15.25,25.7h-9.5l17.25-27.61h-17.88v-6.98h25.38v-4.78h10v4.78h7.75v6.98h-7.75v27.61h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.09,66.69l.22-1.95h-10l-2.47,22.39h10l1.46-13.41h20.09l-2.43,28.97h10l2.86-34.27c.08-.93-.66-1.73-1.59-1.73h-28.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m280.88,103.69v-7.12h21.19l11.06-32.25h10.88l-13.13,38.29c-.22.65-.83,1.08-1.51,1.08h-28.48Zm0-33.25v-6.12h15.38v6.12h-15.38Zm0,13.62v-6.12h15.38v6.12h-15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.63,103.69v-5.34h26.24v-7.72h-26.24v-5.26h26.24v-5.41h-26.24v-5.34h34.41c.79,0,1.43.64,1.43,1.43v26.21c0,.79-.64,1.43-1.43,1.43h-34.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m377.1,71.44v-7.12h15.38v7.12h-15.38Zm0,32.25v-7.31h20.29l10.96-29.06h11.88l-13.11,35.33c-.23.63-.83,1.05-1.51,1.05h-28.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconAndTextHorizontal);
export default __webpack_public_path__ + "static/media/LogoIconAndTextHorizontal.6536b21f3b3214b728bb751011b747b0.svg";
export { ForwardRef as ReactComponent };